var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', _vm._b({
    attrs: {
      "max-width": "1440",
      "content-class": "rounded-0"
    },
    on: {
      "click:outside": function clickOutside($event) {
        return _vm.$emit('close');
      }
    }
  }, 'v-dialog', _vm.$attrs, false), [_c('v-toolbar', {
    attrs: {
      "height": "auto"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "transparent",
    attrs: {
      "icon": "",
      "color": "grey6"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('close');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "34"
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('v-card', {
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "py-40 py-md-60 py-lg-80"
  }, [_c('v-container', {
    staticClass: "container--small"
  }, [_vm._t("default")], 2)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }